<template>
  <zm-alert class="opc-edu-switch-tip" type="info" :closable="false" :show-icon="false">
    <i class="zm-icon-info opc-edu-switch-tip__icon" aria-hidden="true" />
    <div class="opc-edu-switch-tip__message">{{$t('billing.zone_edu_sch.switch_info', [plan,$t('billing.planform.title.zoom_one_education')])}}</div>
  </zm-alert>
</template>

<script>
export default {
 props: {
    plan: {
      type: String,
    },
  }
}
</script>



<style lang="scss" scoped>
.opc-edu-switch-tip {
  margin-bottom: 24px;
  background-color: #f7f7f8;

  ::v-deep {
    .zm-alert {
      &__body {
        padding: 0;
      }
      &__description {
        display: flex;
        align-items: center;
      }
    }
  }

  &__icon {
    flex-shrink: 0;
    font-size: 16px;
    color: #666487;
  }
  &__message {
    flex-grow: 1;
    margin-left: 16px;
    line-height: 1.5;
    font-size: 14px;
    font-weight: 450;
    font-style: normal;
    color: #666487;
  }
}
</style>
